export default __webpack_public_path__ + "static/media/card.47aff92a.svg";